import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { ProfileFlagPage } from '@/components/ProfileFlagPage';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type, data } = decoded;

  switch (type) {
    case 'npub':
      return <ProfileFlagPage pubkey={data as string} />;

    case 'nprofile':
      return <ProfileFlagPage pubkey={(data as { pubkey: string }).pubkey} />;

    default:
      return <NotFound />;
  }
}
